import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useDeps } from '@Contexts/DI';
import filterInStock from './helpers/filterInStock';
import useKeys from './useKeys';

import type { ConfiguratorData } from '@Pages/PageProduct';

const useToggleInStock = () => {
  const { logger } = useDeps();
  const queryClient = useQueryClient();
  const { configurator: keys, stock: mutationKey } = useKeys();

  const { mutateAsync } = useMutation<boolean, Error, boolean>({
    mutationKey,
    mutationFn: async (value: boolean) => {
      queryClient.setQueryData<boolean>(mutationKey, value);
      return value;
    },
    onSuccess: (inStock) => {
      queryClient.setQueryData(keys, (prev: ConfiguratorData) => {
        if (!prev) return;

        return {
          ...prev,
          tabs: filterInStock({ tabs: prev.tabs, inStock }),
        };
      });
    },
    onError: (error) => {
      logger.error('Error toggling in stock:', error);
    },
  });

  return {
    toggleInStock: mutateAsync,
  };
};

export default useToggleInStock;
